module.exports = __webpack_public_path__ + "img/202412_skincareoil.a2779700.jpg";